import React, { useState, useEffect } from "react";
import "../components/styles/MyPage.css";
import MyPageSection from "../components/mypage/MyPageSection";
import MyPageSidebar from "../components/mypage/MyPageSidebar";
import UserProfile from "../components/mypage/UserProfile";
import PurchaseHistorySection from "../components/mypage/PurchaseHistorySection";
import ReviewManagementSection from "../components/mypage/ReviewManagementSection";
import QnaManagementSection from "../components/mypage/QnaManagementSection";

const MyPage = () => {
    const [myData, setMyData] = useState([]); // 사용자 프로필 데이터
    const [purchaseHistory, setPurchaseHistory] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [reviewableItemsCount, setReviewableItemsCount] = useState(0);
    const [myReviews, setMyReviews] = useState([]);
    const [myReviewCount, setMyReviewCount] = useState(0);
    const [qna, setQna] = useState([]);
    const [qnaCount, setQnaCount] = useState(0);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        fetchMyPageData();
    }, []);

    const fetchMyPageData = async () => {
        try {
            const response = await fetch("/api/mypage"); // ✅ 실제 API 호출
            if (response.ok) {
                const data = await response.json();

                // ✅ 사용자 프로필 설정
                setMyData(
                    data.myManagementData != "noData" ? data.myManagementData : []
                );


                // ✅ 구매 내역 설정
                setPurchaseHistory(
                    data.myPurchaseData !== "noData" ? data.myPurchaseData : []
                );

                // ✅ 리뷰 데이터 설정
                // 리뷰 가능한 상품 개수 설정
                setReviewableItemsCount(
                    data.reviewableItemsCounts !== "noData" ? data.reviewableItemsCounts : 0
                );

                setReviews(
                    data.reviewableItems !== "noData" ? data.reviewableItems : []
                );

                // 내가 작성한 리뷰 개수 설정
                setMyReviewCount(
                    data.myReviewDataCounts !== "noData" ? data.myReviewDataCounts : 0
                );
                setMyReviews(
                    data.myReviewData !== "noData" ? data.myReviewData : []
                );

                // ✅ Q&A 데이터 설정
                // Q&A 개수 설정
                setQnaCount(
                    data.qnaManagementDataCounts !== "noData" ? data.qnaManagementDataCounts : 0
                );
                setQna(
                    data.qnaManagementData !== "noData" ? data.qnaManagementData : []
                );
            }
        } catch (error) {
            console.error("마이페이지 데이터 불러오기 실패:", error);
        } finally {
            setLoading(false);
        }
    };

    // ✅ Q&A 데이터 갱신
    const refreshQnaData = () => {
        setLoading(true);
        fetchMyPageData();
    };

    if (loading) return <p>로딩 중...</p>;

    return (
        <div className="mypage-layout">
            <MyPageSidebar />
            <div className="mypage-content">
                <h2 className="mypage-title">MY 관리</h2>
                <UserProfile myData={myData} />
                <PurchaseHistorySection purchases={purchaseHistory} />
                <ReviewManagementSection reviewableItemsCount={reviewableItemsCount} myReviewCount={myReviewCount} reviews={reviews} myReviews={myReviews} />
                <QnaManagementSection qnaList={qna} qnaCount={qnaCount} refreshQnaData={refreshQnaData} />
            </div>
        </div>
    );
};

export default MyPage;
